module.exports = __webpack_public_path__ + "img/BagicSvg3.f6d635f7.svg";